(() => {
  const body = document.body;
  if (!body.classList.contains('template-index')) return;
  const hero = document.querySelector('#MainContent .section-slideshow');
  if (!hero || !('IntersectionObserver' in window)) {
    body.classList.add('verner-hero-cleared');
    return;
  }
  const observer = new IntersectionObserver(([entry]) => {
    body.classList.toggle('verner-hero-cleared', !entry.isIntersecting);
  }, { threshold: 0 });
  observer.observe(hero);
})();
/* VERNER: rewards popup alignment */
(() => {
  if (window.vernerRewardsAlignmentLoaded) return;
  window.vernerRewardsAlignmentLoaded = true;

  const normalize = text => text.replace(/\s+/g, ' ').trim();
  const centered = new Set([
    'Welcome to',
    'VERNER V-Points',
    'תוכנית הנקודות',
    'צוברים נקודות בכל רכישה'
  ]);

  const css = `
    .gw-rd-popup-widget-launcher-btn.gw-btn {
      border-radius: 4px !important;
    }

    .gw-rd-popup-widget-container {
      left: 50% !important;
      right: auto !important;
      transform: translateX(-50%) !important;
      max-width: calc(100vw - 32px) !important;
    }

    .rewards-general-theme {
      direction: rtl !important;
    }

    .rewards-general-theme .gw-layout-text,
    .rewards-general-theme h1,
    .rewards-general-theme h2,
    .rewards-general-theme h3,
    .rewards-general-theme p {
      direction: rtl !important;
      text-align: right !important;
    }

    .rewards-general-theme [data-verner-center] {
      text-align: center !important;
      width: 100% !important;
      box-sizing: border-box !important;
    }

    .rewards-general-theme [data-verner-english] {
      direction: ltr !important;
    }
  `;

  function apply(root) {
    if (root.querySelector(
      '.gw-rd-popup-widget-launcher-btn, .gw-rd-popup-widget-container, .rewards-general-theme'
    )) {
      if (!root.querySelector('#verner-rewards-permanent')) {
        const style = document.createElement('style');
        style.id = 'verner-rewards-permanent';
        style.textContent = css;
        root.appendChild(style);
      }

      const theme = root.querySelector('.rewards-general-theme');

      if (theme) {
        const texts = theme.querySelectorAll(
          '.gw-layout-text, h1, h2, h3, p'
        );

        texts.forEach(element => {
          const text = normalize(element.textContent);
          const joinText =
            text.includes('הצטרפו למועדון') &&
            text.includes('מהטבות מיוחדות');

          if (centered.has(text) || joinText) {
            element.setAttribute('data-verner-center', '');
          }

          if (text === 'Welcome to' || text === 'VERNER V-Points') {
            element.setAttribute('data-verner-english', '');
          }
        });

        const welcome = [...theme.querySelectorAll('span')]
          .find(element =>
            element.children.length === 0 &&
            normalize(element.textContent) === 'Welcome to'
          );

        if (welcome) {
          welcome.style.setProperty(
            'font-size', '16.8px', 'important'
          );
          welcome.style.setProperty(
            'line-height', '1.4', 'important'
          );

          const group = welcome.parentElement;
          const frame = group?.parentElement?.parentElement;

          if (
            group && frame &&
            group.textContent.includes('VERNER V-Points')
          ) {
            group.style.setProperty(
              'text-align', 'center', 'important'
            );

            const groupRect = group.getBoundingClientRect();
            const frameRect = frame.getBoundingClientRect();

            if (groupRect.width && frameRect.width) {
              const previous =
                Number(group.dataset.vernerShift || 0);

              const difference =
                frameRect.left + frameRect.width / 2 -
                (groupRect.left + groupRect.width / 2);

              const shift = previous + difference;

              group.style.setProperty(
                'translate', `${shift}px 0`, 'important'
              );
              group.dataset.vernerShift = String(shift);
            }
          }
        }
      }
    }

    root.querySelectorAll(
      '.gw-rd-popup-widget-placeholder, .gw-rd-popup-root-widget-wrapper'
    ).forEach(element => {
      if (element.shadowRoot) apply(element.shadowRoot);
    });
  }

  const nudgeCss = `
.gw-nudges-popup-widget-container {
  --gw-ng-primary-color: #111;
  --gw-nudges-buttons__theme-color: #000;
  --gw-nudges-buttons__font-color: #fff;
  background-color: #fff;
}
.gw-nudges-popup-widget__content {
  direction: rtl;
  text-align: right;
}
.gw-nudges-popup-widget__image-wrapper img {
  filter: grayscale(1);
}
@media (max-width: 767px) {
  .gw-nudges-popup-widget-container--BL {
    bottom: 156px !important;
  }
}
`;

  function update() {
    if (document.hidden) return;
    apply(document);
    document.querySelectorAll('.gw-nudges-popup-widget-placeholder').forEach(host => {
      const root = host.shadowRoot;
      if (!root || root.querySelector('#verner-nudge-style')) return;
      const style = document.createElement('style');
      style.id = 'verner-nudge-style';
      style.textContent = nudgeCss;
      root.appendChild(style);
    });
  }

  update();
  window.setInterval(update, 1000);
  window.addEventListener('resize', update);
})();
